import React from 'react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
const deliverables = [{
  number: '6',
  label: 'Comprehensive Volumes',
  body: 'Six practical volumes covering the initial assessment, red-flag screening, examination procedures, clinical reasoning, differential considerations, and educational cases.'
}, {
  number: '5',
  label: 'Specialized Bonuses',
  body: 'Five complementary resources, including assessment checklists, screening worksheets, documentation templates, and case-review exercises.'
}, {
  number: '15',
  label: 'Minute Workflow Framework',
  body: 'A practical framework for organizing key components of an initial assessment within a 15-minute workflow target.'
}];
export function DeliverablesSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-133" data-mp="1cj68l2s6wjfx">
      <SectionHeader tone="dark" eyebrow="Here’s what you’ll receive" title="Everything You Need in One Organized Collection" data-id="element-134" data-mp="17lnznce6a47x" />

      <div className="mx-auto mt-12 grid max-w-6xl gap-px overflow-hidden rounded-2xl bg-white/10 md:grid-cols-3" data-id="element-135" data-mp="2jpbdmjo3k3yo">
        {deliverables.map(d => <div key={d.label} className="flex flex-col bg-navy-800 p-7 sm:p-8" data-id="element-136" data-mp="2tg62zwwn3joc">
            <span className="font-display text-8xl font-black leading-none text-brand" data-id="element-137" data-mp="2ti93javf4v7b">{d.number}</span>
            <h3 className="mt-2 font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-138" data-mp="2yhc16a92jz59">{d.label}</h3>
            <p className="mt-3 text-base leading-relaxed text-slate-300" data-id="element-139" data-mp="25qk2n64j6yer">{d.body}</p>
          </div>)}
      </div>

      <p className="mx-auto mt-6 max-w-3xl text-center text-sm leading-relaxed text-slate-400" data-id="element-140" data-mp="2apeyb8nlkhga">
        The 15-minute target is an organizational goal, not a guarantee that every patient can be fully assessed within that time. Clinical
        complexity, safety considerations, and individual presentation may require additional time.
      </p>

      <CtaButton tone="dark" label="Get Instant Access for $27" sub="One-time payment · No subscription · Digital educational resources" data-id="element-141" data-mp="3q4lxm7elwj8b" />
    </section>;
}